module.exports = __webpack_public_path__ + "europa-50-front.jpg?4764e94519892b89fc06aaa1f9ec6ad4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-front.jpg
// module id = 359
// module chunks = 0